export default [{
  path: '/mine/helpCenter',
  name: 'helpCenter',
  meta: {
    index: 14
  },
  component: () => import('@/views/mine/helpCenter.vue')
}]
